import { IFormulationDetailsByPID } from "@redux/reducers/formulationDevReducer";

export enum ActionType {
  FORMULATION_DETAILS_BY_PID = "FORMULATION_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IProjectDetailsByPid {
  type: ActionType.FORMULATION_DETAILS_BY_PID;
  payload: IFormulationDetailsByPID[];
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IProjectDetailsByPid | IResetReduxState;
